// @flow

export function getWebsiteChatURL (path: string = ''): string {
  const domain = process.env.DOMAIN || 'chatchamp.com'
  const subdomain = process.env.WEBSITE_CHAT_SUBDOMAIN || 'chat'

  return `https://${subdomain}.${domain}${path}`
}
